/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../../components/ui-elements/loader';
import BackButton from '../../../../../../components/shared/Buttons/BackButton';
import MainCard from '../../../../../../components/ui-elements/cards/MainCard';
import { getUserInfo } from '../../../../../../store/reducers/user/userAction';
import UserProfileInformations from './UserProfileInformations';
import UserUpdateForm from './UserUpdateForm';
import UserUpdatePassword from './UserUpdatePassword';

const Account = () => {
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState(false);
    const [editPwd, setEditPwd] = useState(false);

    const dispatch = useDispatch();

    // Function to fetch user info from the Redux store
    const fetchUserInfo = useCallback(async () => {
        try {
            await dispatch(getUserInfo()).unwrap();
        } catch (error) {
            console.error("Error fetching user info:", error);
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    // Fetch user info on component mount
    useEffect(() => {
        fetchUserInfo();
    }, [fetchUserInfo]);

    return (
        <Box m={6}>

            {/* Back button with title */}
            <Grid container spacing={4} >
                <Grid item xs={12} sm={12} md={12}>
                    {/* Back button with title */}
                    <BackButton pageTitle="Contact Information" />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>

                    <MainCard>
                        {/* Show loader while fetching data */}
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                {/* Render user profile or edit/update forms based on state */}
                                {!editPwd ? (
                                    !edit ? (
                                        <UserProfileInformations
                                            toggleEdit={setEdit}
                                            toggleEditPwd={setEditPwd}
                                            changeLoading={setLoading}
                                        />
                                    ) : (
                                        <UserUpdateForm toggleEdit={setEdit} />
                                    )
                                ) : (
                                    <UserUpdatePassword
                                        toggleEdit={setEdit}
                                        toggleEditPwd={setEditPwd}
                                        changeLoading={setLoading}
                                    />
                                )}
                            </>
                        )}
                    </MainCard>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Account;
